export default {
  labels: {
    free_items: 'Bezpłatne pozycje',
    bogo: 'Kup jeden, drugi gratis',
    order_again: 'Zamów ponownie',
  },
};
